// extracted by mini-css-extract-plugin
module.exports = {"rtoBanner":"_3g9Da","banner":"f3WIe","bannerText":"_1tJGi","rtoRegNo":"_23ldb","textWrapper":"_1j6DV","divider":"LVVeU"};